export default "__VITE_ASSET__xrzgRikY__"